import './style.scss';

interface IProps {
  lat?: number;
  lng?: number;
  className?: string;
}
const Indicator = (props: IProps) => {
  return (
    <div className={`indicator-wrapper ${props.className || ''}`}>
      <div className="indicator">
        <div className="indicator-range">
          <div className="indicator-dot"></div>
        </div>
      </div>
    </div>
  );
};

export default Indicator;
